export const methodology = {
  text: "Méthodologie",
  title1: "Notre approche",
  paragraph1:
    "Début 2016, l'équipe du GDHM, en collaboration avec des représentants de plus de 20 pays et de plus de 50 agences et organisations internationales, " +
    "a conçu la version 1.0 du Global Digital Health Index (GDHI). En 2022, la ressource a fait l'objet d'un processus d'examen et de refonte des indicateurs " +
    "et de la plate-forme d'un an pour aligner les indicateurs sur la Stratégie mondiale de santé numérique de l'OMS en complément de l'Atlas numérique de la santé de l'OMS et met davantage l'accent sur l'IA, " +
    "l'équité, le genre et Couverture santé universelle. En outre, le nom a été changé en Global Digital Health Monitor (GDHM) pour exprimer la valeur de l'outil en fournissant une plate-forme pour suivre les progrès de la santé numérique aux niveaux national, " +
    "régional et mondial. Le GDHM mis à jour comprend des visualisations de pays pour le suivi des performances d'une année sur l'autre, des visualisations régionales et des comparaisons de pays à pays.",
  bulletin: {
    title: "Pour élaborer les indicateurs, l'équipe de le GDHM a:",
    line1:
      "Réalisé une étude panoramique des données mondiales disponibles par l'intermédiaire d'organisations multilatérales.",
    line2:
      "Procédé à la cartographie des données disponibles en examinant les cadres et les outils existants mis au point par des experts " +
      "pour aider les praticiens et les pays à évaluer la force et la maturité de l'environnement favorable à la santé numérique.",
    line3:
      "Et a réuni des experts en santé numérique pour élaborer les cas d'utilisation de le GDHM et affiner et définir un ensemble " +
      "initial d'indicateurs recommandés pour en faire une liste conviviale et gérable.",
  },
  paragraph2: "Liste des indicateurs de le GDHM -",
  seeHere: "Voir ici",

  title2: "Collecte et vérification des données",
  paragraph3Start:
    "L'équipe de le GDHM travaille avec des partenaires nationaux et des représentants du ministère de la Santé qui dirigent " +
    "les efforts de santé numérique dans leurs pays respectifs pour recueillir des données pour chaque pays. Ces pays partenaires soumettent " +
    "les données de leur pays dans le cadre d'une enquête annuelle de le GDHM et choisissent le niveau appropriée pour chaque indicateur " +
    "ainsi que la justification et les preuves à l'appui des niveaux choisis. L'équipe de le GDHM vérifie les données recueillies avant " +
    "de les publier. Des données plus larges sur la santé provenant des ",
  paragraph3Link: "Indicateurs de développement de la Banque mondiale 2019",
  paragraph3End:
    " ont été incluses pour contextualiser la maturité de la santé numérique.",

  title3: "Calcul des moyennes et analyse comparative",
  paragraph4:
    "Le GDHM utilise les principaux indicateurs de chaque catégorie pour calculer la moyenne nationale globale. Bien que des " +
    "sous-indicateurs soient inclus pour ajouter une plus grande spécificité à des indicateurs spécifiques de le GDHM, ils ne sont pas " +
    "utilisés pour calculer le niveau de la composante ou les moyennes nationales ou mondiales. Le GDHM permet aux pays de se comparer à " +
    "la moyenne mondiale ou à une phase globale spécifique.",
  title4: "Données préremplies provenant de sources accessibles au public",
  paragraph5:
    "Pour les pays qui n'ont pas répondu à une enquête dans le Global Digital Health Monitor, les données ont été extraites des informations accessibles au public pour pré-remplir les indicateurs ci-dessous afin de donner une idée générale de la maturité plus large de l'écosystème numérique en alignement avec les indicateurs pertinents. Bien que ces données servent de proxy pour ces indicateurs de santé numérique pour les pays, les données complétées par les responsables gouvernementaux fournissent une image plus précise et plus solide des progrès de la santé numérique dans chaque pays. Nous encourageons les pays qui n'ont pas soumis de données complètes à demander un lien de pays à le faire dès que possible.",
  indicators: {
    bulletin: {
      title:
        "Indicateurs qui ont utilisé des données indirectes provenant de sources accessibles au public pour pré-remplir les pays qui n'ont pas répondu à une enquête: ",
      line1:
        "Indicateur 2a : La santé est une priorité dans les politiques nationales de transformation numérique et de gouvernance des données",
      line2:
        "Indicateur 4 : Analyse, planification et suivi de la diversité, de l'équité et des droits de l'homme inclus dans les stratégies et plans nationaux de santé numérique",
      line3:
        "Indicateur 6a : participation et investissements du secteur privé dans la santé numérique",
      line4:
        "Indicateur 7 : cadre juridique de la protection des données (sécurité)",
      line5:
        "Indicateur 8 : Lois ou réglementations relatives à la vie privée, au consentement, à la confidentialité et à l'accès aux informations sur la santé (Confidentialité)",
      line6:
        "Indicateur 9 : Protocole de réglementation ou de certification des dispositifs et/ou des services de santé - y compris des dispositions pour l'IA et les algorithmes (à des stades de maturité plus élevés)",
      line7: "Indicateur 17 : État de préparation du réseau",
      line8:
        "Indicateur 18 : Planification et soutien pour la maintenance continue de l'infrastructure de santé numérique",
    },
    paragraph: {
      start: "Les sources de données comprenaient le",
      govTech: "Indicateur de maturité GovTech",
      GTMI: "(GTMI)",
      NRI: "Indice de préparation du réseau",
      GCI: "Indice mondial de cybersécurité",
      GSMA: "Indice de connectivité mobile GSMA",
      the: "le",
      andThe: "et le",
    },
  },
};
